import { render, staticRenderFns } from "./footerACS.vue?vue&type=template&id=8cc3f5d4&"
import script from "./footerACS.vue?vue&type=script&lang=js&"
export * from "./footerACS.vue?vue&type=script&lang=js&"
import style0 from "./footerACS.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports